module.exports = __webpack_public_path__ + "img/ayuda-user-spotify-id-795x100.56746e43.png";